import React, { Component } from "react";
import PropTypes from "prop-types";
import { Link } from "react-router-dom";

// Redux
import { connect } from "react-redux";

// Material imports
import withStyles from "@material-ui/core/styles/withStyles";
import Grid from "@material-ui/core/Grid";
import Button from "@material-ui/core/Button";
import Typography from "@material-ui/core/Typography";

import chromeImage from "../images/chromeExtLanding.png";

// widgets
// import Emoji from "../components/widgets/Emoji";

const styles = (theme) => ({
  ...theme.spreadThis,
  root: {
    flexGrow: 1,
  },
  heroContent: {
    backgroundColor: theme.palette.background.paper,
    padding: theme.spacing(8, 0, 6),
  },
  paper: {
    padding: theme.spacing(2),
    marginTop: 0,
    marginBottom: 10,
    textAlign: "center",
    color: theme.palette.secondary,
    borderRadius: 15,
  },
  paperFilter: {
    padding: theme.spacing(2),
    marginTop: 0,
    marginBottom: 10,
    textAlign: "left",
    color: theme.palette.secondary,
    borderRadius: 15,
  },
  landingTop: {
    marginTop: 50,
  },
});

class landing extends Component {
  render() {
    // const { classes } = this.props;
    var userFeed = (
      <div>
        <Grid
          container
          spacing={2}
          alignItems="center"
          justify="center"
          style={{ minHeight: "75vh" }}
        >
          <Grid item xs={4}>
            <Typography variant="h2" align="left">
              Find your fit
            </Typography>
            <Typography variant="h5" align="left" style={{ marginTop: 10 }}>
              Fitcheck helps you discover what size to purchase based on the
              community reviews
            </Typography>
            <Button
              variant="contained"
              color="primary"
              style={{ marginTop: 20 }}
              component={Link}
              to="/signup"
            >
              Join Us!
            </Button>
          </Grid>
          <Grid item xs={2} />
          <Grid item xs={4}>
            {/* <Typography variant="h2" align="center">
              Photo of Chrome Extension
            </Typography> */}
            <img src={chromeImage} alt="extension" />
          </Grid>
        </Grid>
      </div>
    );
    return userFeed;
  }
}

landing.propTypes = {
  classes: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => ({
  user: state.user,
  data: state.data,
});

export default connect(mapStateToProps)(withStyles(styles)(landing));
